import { createAction, props } from '@ngrx/store';

export interface InvoiceProcessBatch {
    id: string;
    index: number;
    totalCount: number;
}

export const processInvoiceSuccess = createAction(
    '[HUB CONNECTION SERVICE] Process Invoice Success',
    props<{ invoiceId: number; batch: InvoiceProcessBatch }>()
);

export const processInvoiceFailure = createAction(
    '[HUB CONNECTION SERVICE] Process Invoice Failure',
    props<{ error: string; batch: InvoiceProcessBatch }>()
);

export const ensureConnectedToInvoiceProcessingFeed = createAction('[INVOICE COMPONENT] Loading component');
export const disconnectFromInvoiceProcessingFeed = createAction('[INVOICE COMPONENT] Destroying component');
